<div class="vde" [style.paddingTop.px]="espacioHeader">

  <!-- Banner de premios con fecha y precio encima -->
  <section class="vde-banner">
    <img src="/assets/img/sorteo2026/banner-venta-externa.jpg" alt="Premios Sorteo Anáhuac Magno 2026" class="vde-banner__img">

    <div class="vde-banner__izq">
      <p class="vde-magno">SORTEO MAGNO</p>
      <div class="vde-fecha">
        <img class="vde-a" src="/assets/img/sorteo2026/icono-a.png" alt="">
        <span class="vde-fecha__texto">19<i>•</i>NOV<i>•</i>2026</span>
      </div>
    </div>

    <div class="vde-banner__der">
      <div class="vde-ultimos">
        <p class="vde-ultimos__titulo">¡ÚLTIMOS BOLETOS!</p>
        <div class="vde-ultimos__fila">
          <img class="vde-a vde-a--chica" src="/assets/img/sorteo2026/icono-a.png" alt="">
          <p class="vde-ultimos__precio">Boleto: $500</p>
        </div>
      </div>
    </div>
  </section>

  <section class="vde-main">
    <div class="container">

      <!-- Titulo -->
      <header class="vde-titulo">
        <h1 class="vde-titulo__maquina">MÁQUINA</h1>
        <p class="vde-titulo__de">de la <span class="vde-titulo__suerte">suerte</span></p>
        <p class="vde-titulo__sub">Descubre tu número de la suerte</p>
      </header>

      <div class="row align-items-center">

        <!-- Maquina -->
        <div class="col-lg-6 vde-col-maquina">
          <div class="vde-maquina-wrap" [class.vde-jalando]="girando">

            <button type="button" class="vde-activar" (click)="activar()" [disabled]="!puedeGirar">
              <span>ACTIVAR</span>
            </button>

            <div class="vde-maquina" [class.vde-maquina--premio]="boletoActual">
              <div class="vde-marca">
                <img src="/assets/img/sorteo2026/logo-magno.png" alt="Sorteo Anáhuac Magno" class="vde-marca__logo">
              </div>

              <div class="vde-rodillos">
                <div class="vde-rodillo" *ngFor="let r of rodillos">
                  <ul [id]="'vde-n' + r">
                    <li *ngFor="let d of digitosBase">{{ d }}</li>
                    <li *ngFor="let d of digitosBase">{{ d }}</li>
                  </ul>
                </div>
              </div>

              <!-- Antes de girar: activa. Al caer un boleto: agregar al carrito ahi mismo. -->
              <button *ngIf="!boletoActual" type="button" class="vde-cta" (click)="activar()" [disabled]="!puedeGirar">
                <ng-container *ngIf="cargando">Cargando boletos...</ng-container>
                <ng-container *ngIf="!cargando && girando">Girando...</ng-container>
                <ng-container *ngIf="!cargando && !girando">¡Activa tu suerte AQUÍ!</ng-container>
              </button>

              <button *ngIf="boletoActual" type="button" class="vde-cta vde-cta--carrito" (click)="agregarAlCarrito()"
                [disabled]="validando">
                <ng-container *ngIf="!validando">
                  Agregar al carrito
                  <svg class="vde-cta__icono" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M7 18a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm10 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zM5.2 4l.6 3H21l-2 8H7.4l.4 2H19v2H6.2L3.6 6H2V4h3.2z" />
                  </svg>
                </ng-container>
                <ng-container *ngIf="validando">Validando...</ng-container>
              </button>
            </div>

            <div class="vde-palanca" aria-hidden="true">
              <span class="vde-palanca__bola"></span>
              <span class="vde-palanca__barra"></span>
              <span class="vde-palanca__base"></span>
            </div>
          </div>
        </div>

        <!-- Fecha y precio -->
        <div class="col-lg-6 vde-col-info">
          <p class="vde-magno">SORTEO MAGNO</p>
          <div class="vde-fecha">
            <img class="vde-a" src="/assets/img/sorteo2026/icono-a.png" alt="">
            <span class="vde-fecha__texto">19<i>•</i>NOV<i>•</i>2026</span>
          </div>

          <div class="vde-ultimos">
            <p class="vde-ultimos__titulo">¡ÚLTIMOS BOLETOS!</p>
            <p class="vde-ultimos__precio">Boleto: $500</p>
          </div>
        </div>
      </div>

      <!-- Avisos -->
      <div class="vde-panel">
        <p *ngIf="errorCarga" class="vde-estado vde-estado--error">
          No pudimos cargar los boletos. Recarga la página para intentarlo de nuevo.
        </p>

        <p *ngIf="!cargando && !errorCarga && sinBoletos && !boletoActual" class="vde-estado">
          Por el momento no hay boletos disponibles en esta liga.
        </p>

        <div *ngIf="mensajesNoDisponibles.length > 0" class="vde-aviso">
          <p *ngFor="let m of mensajesNoDisponibles">{{ m }}</p>
        </div>
      </div>

    </div>
  </section>

  <!-- Segunda opcion: elegir boletos de la lista -->
  <section class="vde-lista" *ngIf="!errorCarga && (cargando || disponibles.length > 0)"
    [class.vde-lista--con-barra]="seleccionLista.size > 0">
    <div class="container">

      <header class="vde-lista__head">
        <h2 class="vde-lista__titulo">O selecciona tus boletos</h2>
        <p class="vde-lista__sub">Toca los números que más te gusten y agrégalos al carrito.</p>

        <label class="vde-buscar">
          <input type="text" inputmode="numeric" maxlength="6" placeholder="Busca tu número"
            [(ngModel)]="filtroLista" [disabled]="cargando">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M10 2a8 8 0 0 1 6.32 12.9l5.39 5.39-1.42 1.42-5.39-5.39A8 8 0 1 1 10 2zm0 2a6 6 0 1 0 0 12 6 6 0 0 0 0-12z" />
          </svg>
        </label>
      </header>

      <p *ngIf="cargando" class="vde-estado">Cargando boletos...</p>

      <div class="vde-boletos" *ngIf="!cargando">
        <button type="button" class="vde-boleto" *ngFor="let b of boletosLista"
          [class.vde-boleto--sel]="estaSeleccionado(b)" (click)="alternar(b)" [disabled]="validandoLista">
          <span class="vde-boleto__label">Boleto</span>
          <span class="vde-boleto__folio">{{ folioTexto(b) }}</span>
          <span class="vde-boleto__check" aria-hidden="true">
            <svg viewBox="0 0 24 24"><path d="M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z" /></svg>
          </span>
        </button>
      </div>

      <p *ngIf="!cargando && filtroLista && boletosLista.length === 0" class="vde-estado">
        No encontramos boletos con ese número.
      </p>

      <div *ngIf="mensajesLista.length > 0" class="vde-aviso">
        <p *ngFor="let m of mensajesLista">{{ m }}</p>
      </div>
    </div>

    <!-- Tarjeta flotante: aparece al elegir el primer boleto y sigue al usuario por toda la
         pagina (position: fixed), asi el boton se ve aunque la lista tenga 50+ boletos. -->
    <div class="vde-barra" *ngIf="seleccionLista.size > 0" role="region" aria-label="Boletos seleccionados">
      <div class="vde-barra__contenido">
        <div class="vde-barra__info">
          <span class="vde-barra__conteo">{{ seleccionLista.size }}</span>
          <div class="vde-barra__textos">
            <p class="vde-barra__resumen">
              boleto{{ seleccionLista.size > 1 ? 's' : '' }} seleccionado{{ seleccionLista.size > 1 ? 's' : '' }}
            </p>
            <p class="vde-barra__total">
              Total <strong>{{ totalLista | currency:'MXN':'symbol-narrow':'1.0-0' }}</strong>
              <button type="button" class="vde-barra__limpiar" (click)="limpiarSeleccion()" [disabled]="validandoLista">
                Quitar selección
              </button>
            </p>
          </div>
        </div>
        <button type="button" class="vde-cta vde-cta--carrito vde-barra__btn" (click)="agregarSeleccionados()"
          [disabled]="validandoLista">
          <ng-container *ngIf="!validandoLista">
            Agregar al carrito
            <svg class="vde-cta__icono" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M7 18a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm10 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zM5.2 4l.6 3H21l-2 8H7.4l.4 2H19v2H6.2L3.6 6H2V4h3.2z" />
            </svg>
          </ng-container>
          <ng-container *ngIf="validandoLista">Validando...</ng-container>
        </button>
      </div>
    </div>
  </section>
</div>
